var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"step",class:_vm.classname,on:{"click":_vm.changeStep}}),_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('hide')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }